import React, {Component} from 'react';
import { Button, Input, Select, Dropdown, Container, Menu, Checkbox, Radio, Label, Form } from 'semantic-ui-react';

const publishStateOptions = [
    { key: 'publish', text: '一般公開', value: 'publish' },
    { key: 'private', text: '学内限定', value: 'private' },
    { key: 'close', text: '講義受講者限定', value: 'close' },
    { key: 'researve', text: '予約済み', value: 'researve' },
]


const CategoryOptions = [
    { key: '選択なし', text: '選択なし', value: '' },
    { key: '言語学から', text: '言語学から', value: '言語学から' },
    { key: 'ご当地アイドルを読み解く', text: 'ご当地アイドルを読み解く', value: 'ご当地アイドルを読み解く' },
    { key: '講義ビデオ', text: '講義ビデオ', value: '講義ビデオ' },
    { key: '新聞を読み解く', text: '新聞を読み解く', value: '新聞を読み解く' },
    { key: '最終講義', text: '最終講義', value: '最終講義' },
    { key: '部局長紹介', text: '部局長紹介', value: '部局長紹介' },


]

class SearchConfigPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            sort_method: "date",
            publish_state: []
        }
        this.handleSortMethod = this.handleSortMethod.bind(this);
        this.handlePublishStateChange = this.handlePublishStateChange.bind(this);
        this.handleKwChange = this.handleKwChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
    }

    componentDidMount() {
        this.props.fetchData();
    }

    state = {}
    handleChange = (e, { value }) => this.setState({ value })


    render() {
        return (
            <div>
                <Form inline onSubmit={this.props.handleSubmit}>
                    <Input
                        fluid
                        type="text"
                        placeholder='キーワード...'
                        onChange={this.handleKwChange}
                        action={{icon: 'search'}}
                    />
                    <Menu vertical>
                        <Menu.Item>
                            <Menu.Header>
                                <Label horizontal key="mini" size="mini">実装中</Label>
                                表示順
                            </Menu.Header>
                            <Menu.Menu>
                                <Menu.Item>
                                    <Radio
                                        disabled
                                        label="公開日"
                                        value="date"
                                        name="sort_method"
                                        checked={this.state.sort_method === "date"}
                                        onChange={this.handleSortMethod}
                                    />
                                </Menu.Item>
                                <Menu.Item>
                                    <Radio
                                        disabled
                                        label="再生回数"
                                        value="view_count"
                                        name="sort_method"
                                        checked={this.state.sort_method === "view_count"}
                                        onChange={this.handleSortMethod}
                                    />
                                </Menu.Item>
                            </Menu.Menu>
                        </Menu.Item>
                        <Menu.Item>
                            <Menu.Header>公開範囲</Menu.Header>
                            <Dropdown fluid multiple selection
                                      onChange={this.handlePublishStateChange}
                                      options={publishStateOptions} placeholder='公開範囲を選択…' />
                        </Menu.Item>

                        <Menu.Item>
                            <Menu.Header>人気カテゴリー</Menu.Header>
                            <Dropdown fluid selection
                                      onChange={this.handleCategoryChange}
                                      options={CategoryOptions} placeholder='カテゴリーを選択…' />
                        </Menu.Item>
                    </Menu>
                </Form>
            </div>
        );
    }

    handlePublishStateChange(e, {value}) {
        this.setState({publish_state: value});
        this.props.updateState({publish_state: value});
    }

    handleSortMethod(e, {value}){
        this.setState({sort_method: value});
        this.props.updateState({sort_method: value});
    }

    handleKwChange(event) {
        this.setState({kw: event.target.value});
        this.props.updateState({kw: event.target.value});
    }

    handleCategoryChange(e, {value}) {
        this.setState({category: value});
        this.props.updateState({category: value});
    }

}

export default SearchConfigPanel;


// WEBPACK FOOTER //
// ./src/component/SearchConfigPanel.js